import BoxKit from "@/shared/components/kit/box";
import CustomButton from "@/shared/components/kit/button";
import CardKit from "@/shared/components/kit/card";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import GpsFixedOutlinedIcon from "@mui/icons-material/GpsFixedOutlined";
import { useNavigate } from "react-router";
/**
 * TwentyCardCenters
 *
 * کامپوننت نمایش مراکز ساعی پی شامل گیشه‌ها و پذیرنده‌ها.
 * دارای دکمه‌های دسترسی به نقشه برای هر نوع مرکز است.
 *
 * @returns JSX.Element
 */

const TwentyCardCenters = () => {
  const navigate = useNavigate();
  return (
    <CardKit
      width={"100%"}
      height={152}
      title={
        <StackKit
          direction={"row"}
          justifyContent={"space-between"}
          sx={{ minHeight: "43px" }}
        >
          <StackKit direction={"row"} gap={1}>
            <FmdGoodOutlinedIcon style={{ color: "#082A2E" }} />
            <TypoGraphyKit variant="header">مراکز پذیرنده ساعی</TypoGraphyKit>
          </StackKit>
        </StackKit>
      }
      sx={{
        background: "#fff",
        backdropFilter: " blur(242.1999969482422px)",
      }}
    >
      <StackKit
        sx={{ width: "100%", justifyContent: "center", alignItems: "center" }}
        gap={1}
      >
        <CustomButton
          sx={{
            width: "100%",
            background: "#89C6CE !important",
            cursor: "pointer",
            height: "40px",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px 30px",
            borderRadius: "10px",
          }}
          onClick={() => navigate("/locations")}
        >
          <TypoGraphyKit variant="body1">
            مشاهده مراکز طرف قرارداد با کلینیک ساعی
          </TypoGraphyKit>
        </CustomButton>
      </StackKit>
    </CardKit>
  );
};

export default TwentyCardCenters;
